
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import classNames from 'classnames';
import AppLink from 'components/AppLink/AppLink';
import DeviceList from 'components/DeviceList';
import Layout from 'components/Layout';
import { useAuth } from 'context';
import { Namespace } from 'enums';
import { basicSEO, createRedirectIfNeeded, getNoTrialTranslationKeyIfNeeded, Permalink } from 'helpers';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { StaticPathParams } from 'typings/staticPaths';
import indexStyles from '../index.module.scss';
import styles from './index.module.scss';

interface Props {
  countryCode: string;
}

const HowToWatchWeb = ({ countryCode }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.HowToWatch);
  const { user, locale } = useAuth();

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(
          t('seo:how_to_watch_web_title'),
          t(getNoTrialTranslationKeyIfNeeded('seo:how_to_watch_web_description', countryCode)),
        )}
      </Head>
      <main className={classNames(indexStyles.container, styles.web)}>
        <h1>{t('title')}</h1>
        <DeviceList activeIndex={0} />
        <ul className={indexStyles.blocks}>
          <li>
            <h2>{t('web.supported_browsers')}</h2>
            <ul className={styles.list}>
              <li className={styles.chrome} title="Google Chrome">
                Google Chrome
              </li>
              <li className={styles.edge} title="Microsoft Edge">
                Microsoft Edge
              </li>
              <li className={styles.firefox} title="Firefox">
                Firefox
              </li>
              <li className={styles.opera} title="Opera">
                Opera
              </li>
              <li className={styles.safari} title="Safari">
                Safari
              </li>
            </ul>
            <h2>{t('web.subtitle')}</h2>
            <p>{t('web.content')}</p>
            <AppLink href={Permalink.root(user, locale)}>
              <a className={classNames('btn', 'btn-primary')}>{t('web.button')}</a>
            </AppLink>
          </li>
        </ul>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default HowToWatchWeb;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/web/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  